(function () {
  'use strict';
  if (window.ROGFluidUI) return;
  window.ROGFluidUI = true;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var active = new Map();
  function settle(details, open) {
    var previous = active.get(details);
    if (previous) { previous.animation.onfinish = null; previous.animation.cancel(); active.delete(details); }
    details.open = open;
    details.style.removeProperty('height');
    details.style.removeProperty('overflow');
  }
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-rog-fluid-details] > summary');
    if (!summary || event.defaultPrevented || event.target.closest('a, button, input')) return;
    var details = summary.parentElement;
    if (!details.animate || motion.matches) return;
    event.preventDefault();
    var previous = active.get(details);
    var open = previous ? !previous.open : !details.open;
    var from = details.getBoundingClientRect().height;
    if (previous) { previous.animation.onfinish = null; previous.animation.cancel(); }
    details.open = true;
    details.style.removeProperty('height');
    var to = open ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + 2;
    details.style.overflow = 'hidden';
    var animation = details.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: 240, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both'
    });
    active.set(details, { animation: animation, open: open });
    animation.onfinish = function () { settle(details, open); };
  });
  motion.addEventListener('change', function () {
    if (motion.matches) active.forEach(function (state, details) { settle(details, state.open); });
  });
  // Restore the final state when navigating back, without a stale animation fill.
  window.addEventListener('pagehide', function () { active.forEach(function (state, details) { settle(details, state.open); }); });
  function labelGallery() {
    document.querySelectorAll('.product__medias').forEach(function (gallery) {
      function label() {
        gallery.querySelectorAll('[aria-label^="Go to slide "]').forEach(function (button) {
          var number = button.getAttribute('aria-label').replace('Go to slide ', '');
          button.setAttribute('aria-label', ((window.ROG_T || {}).x_afficher_photo || 'Afficher la photo') + ' ' + number);
        });
      }
      label();
      if (!gallery.hasAttribute('data-rog-gallery-labelled') && window.MutationObserver) {
        gallery.setAttribute('data-rog-gallery-labelled', '');
        new MutationObserver(label).observe(gallery, { childList: true, subtree: true });
      }
    });
  }
  labelGallery();
  document.addEventListener('shopify:section:load', labelGallery);
})();
